import React from "react"
import styled from "styled-components"
import { Flex } from "../../layout/reusables"
import { colors } from "../../styles/colors"
import { Heading, HeadlineText } from "../../styles/typography"

export default function VideoPreviewItem({ item, selectVideo }) {
    
    return (
        <Container onClick={() => selectVideo(item)}>
            <Video
                controls={false}
                preload="metadata"  
            >
                <source src={`${item.url}#t=0.1`} />
            </Video>
            <Title >{item.title}</Title>
            <Description>{item.description}</Description>
        </Container>
    )
}

const Container = styled(Flex)`
    flex-direction: column;
    border-radius: 2px;
    /* padding: 15px; */
    transition: 0.2s ease;
    cursor: pointer;
`
const Video = styled.video`
    height: 250px;
    border-radius: 4px;
    width: 100%;
    margin-bottom: 20px;
    object-fit: cover;
`;

const Title = styled(HeadlineText)`
    font-size: 24px;
    text-decoration: none;
    line-height: 1.3;
    transition: 0.2s ease;
    font-weight: 700;
    margin-bottom: 5px;

    ${Container}:hover & {
        color: ${colors.blue};
    }
`
const Description = styled.p`
    margin-bottom: 10px;
    font-size: 16px;
    line-height: 150%;

    ${Container}:hover & {
        opacity: 0.6;
    }
`
